<template>
  <b-modal :id="modalId" title="Remanejar" size="lg" centered hide-footer
    :no-close-on-backdrop="salvando" :no-close-on-esc="salvando" :hide-header-close="salvando"
    @show="carregar" @hidden="limpar">
    <div v-if="carregando" class="text-center" role="status">Buscando técnicos...</div>
    <b-alert v-if="erro" show variant="danger">{{ erro }}</b-alert>
    <template v-if="!carregando">
      <b-form-input v-model="busca" placeholder="Filtrar pelo técnico ou unidade" aria-label="Filtrar técnicos" />
      <div class="table-responsive mt-3" style="max-height: 45vh; overflow: auto">
        <table class="table table-striped table-sm">
          <thead><tr><th>Selecionar</th><th>Técnico</th><th>Unidade</th></tr></thead>
          <tbody>
            <tr v-for="tecnico in filtrados" :key="tecnico.id">
              <td><b-form-radio v-model="destino" :value="tecnico.id" :name="modalId" :disabled="salvando"
                :aria-label="'Selecionar ' + tecnico.value" /></td>
              <td>{{ tecnico.value }} <small class="d-block">{{ tecnico.profissao || 'Não informado' }}</small></td>
              <td>{{ tecnico.nome_unidade }}</td>
            </tr>
            <tr v-if="!filtrados.length"><td colspan="3">Nenhum técnico elegível encontrado.</td></tr>
          </tbody>
        </table>
      </div>
      <b-form-group v-if="exigeMotivo" label="Motivo do remanejamento" :label-for="modalId + '-motivo'">
        <b-form-textarea :id="modalId + '-motivo'" v-model="motivo" :disabled="salvando" required />
      </b-form-group>
    </template>
    <div class="d-flex justify-content-end mt-3">
      <b-button variant="warning" :disabled="carregando || salvando || !destino || (exigeMotivo && !motivo.trim())"
        @click="salvar">{{ salvando ? 'Remanejando...' : 'Remanejar' }}</b-button>
      <b-button class="ml-2" variant="secondary" :disabled="salvando" @click="$bvModal.hide(modalId)">Fechar</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: { modalId: { type: String, required: true }, servico: { type: String, required: true }, registroId: [String, Number] },
  data() {
    return { tecnicos: [], busca: '', destino: null, motivo: '', erro: '', carregando: false, salvando: false };
  },
  computed: {
    exigeMotivo() { return ['atendimento', 'acompanhamento'].includes(this.servico); },
    endpoint() { return `api/dashboard/remanejamentos/${this.servico}/${this.registroId}`; },
    filtrados() {
      const busca = this.busca.trim().toLocaleLowerCase();
      return this.tecnicos.filter(t => `${t.value || ''} ${t.nome_unidade || ''}`.toLocaleLowerCase().includes(busca));
    },
  },
  methods: {
    mensagem(error) {
      const data = error.response && error.response.data;
      if (data && data.errors) return Object.values(data.errors).flat().join(' ');
      return (data && (data.message || (data.error && data.error.message))) || 'Não foi possível concluir a operação. Tente novamente.';
    },
    async carregar() {
      this.limpar();
      this.carregando = true;
      try { this.tecnicos = (await axios.get(`${this.endpoint}/tecnicos`)).data; }
      catch (error) { this.erro = this.mensagem(error); }
      finally { this.carregando = false; }
    },
    async salvar() {
      if (this.carregando || this.salvando || !this.destino || (this.exigeMotivo && !this.motivo.trim())) return;
      this.salvando = true;
      this.erro = '';
      try {
        await axios.post(this.endpoint, { novo_responsavel: this.destino, motivo: this.motivo || null });
        this.$bvModal.hide(this.modalId);
        this.$emit('remanejado');
        swal.fire({ text: 'Remanejamento realizado com sucesso.', icon: 'success', timer: 3000, showConfirmButton: false });
      } catch (error) { this.erro = this.mensagem(error); }
      finally { this.salvando = false; }
    },
    limpar() { this.tecnicos = []; this.busca = ''; this.destino = null; this.motivo = ''; this.erro = ''; },
  },
};
</script>
